import { GlassCard } from "./GlassCard";

export const StatCard = ({ label, value, sub, testId }) => (
  <GlassCard className="p-8" hover={false}>
    <p className="text-xs font-bold uppercase tracking-[0.2em] text-paper-500">{label}</p>
    <p
      className="mt-4 font-display text-4xl font-semibold tracking-tight text-paper-100 md:text-5xl"
      data-testid={testId}
    >
      {value}
    </p>
    {sub && <p className="mt-2 text-sm text-paper-500">{sub}</p>}
  </GlassCard>
);
